<template>
	<div class="grid-content config">
		<div class="grid-content-title">
			<div class="name">基本设置</div>
		</div>
		<div v-if="loading" style="min-height: 20rem;" v-loading="loading"></div>
		<template v-else>
			<div class="grid-content-content">
				<el-alert style="margin-bottom: 1.25rem;" title="请谨慎修改设置，尽量在所有司机未接单时修改，否则有10分钟缓存时间，修改数据后需要保存生效"
					type="warning" show-icon :closable="false">
				</el-alert>
				<el-form :model="form" ref="configForm" :rules="rules" label-width="120px" size="medium">
					<el-form-item label="区域编码">
						<div class="adcode">{{form.adcode}}</div>
						<div class="tips" style="color: red;">区域编码作为区域接单凭证，若变更请及时联系管理员变更</div>
					</el-form-item>
					<el-form-item label="客服电话" prop="tel">
						<div style="display: inline-block;">
							<el-input v-model="form.tel" placeholder="客服电话" clearable></el-input>
						</div>
						<div class="tips">客户联系时使用</div>
					</el-form-item>
					<el-divider content-position="left" style="margin: 1.25rem 0;">司机端设置</el-divider>
					<el-form-item label="余额风控">
						<div style="display: inline-block;">当司机余额少于</div>
						<div style="display: inline-block; width: 8rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.yerisk" controls-position="right"
								:min="0" :max="1000" :precision="2"></el-input-number>
						</div>
						<div style="display: inline-block;">元，不可上线听单和接单</div>
					</el-form-item>
					<el-form-item label="异常提醒" prop="auto_zhuan">
						<div style="display: inline-block;">订单超过</div>
						<div style="display: inline-block; width: 7rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.remind" controls-position="right"
								:min="0" :max="60" :precision="0"></el-input-number>
						</div>
						<div style="display: inline-block;padding: 0 0.5rem;">分钟出现异常时（未看单、未调度等），司机管理端自动提示</div>
						<div class="tips">如为0则不提示</div>
					</el-form-item>
					<el-form-item label="里程曲线补偿">
						<div style="display: inline-block;">总里程大于</div>
						<div style="display: inline-block; width: 8rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.curve_km" controls-position="right"
								:min="0" :max="100" :precision="3"></el-input-number>
						</div>
						<div style="display: inline-block;">公里时，按总里程</div>
						<div style="display: inline-block; width: 8rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.curve_pa" controls-position="right"
								:min="0" :max="100" :precision="0"></el-input-number>
						</div>
						<div style="display: inline-block;">%</div>
						<div class="tips">部分司机端定位不精确，可使用此功能做补偿，但建议不超过10%</div>
					</el-form-item>
					<el-form-item label="通用验证码">
						<div class="besms">{{form.besms}}</div>
						<div class="el-icon-refresh-right" @click="refreshBesms"></div>
						<div class="tips">当司机手机号码接收不到验证码时，可使用此验证码登录司机端</div>
					</el-form-item>
					<el-divider content-position="left" style="margin: 1.25rem 0;">订单相关设置</el-divider>
					<el-form-item label="调单方式">
						<el-radio-group v-model="form.pai" size="small">
							<el-radio :label="0">手动</el-radio>
							<el-radio :label="1">自动</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="form.pai==1" label="调单范围">
						<div style="display: inline-block;">订单与司机距离小于</div>
						<div style="display: inline-block; width: 8rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.range_x" controls-position="right"
								:min="1" :max="10" :precision="3"></el-input-number>
						</div>
						<div style="display: inline-block;padding: 0 0.5rem;">公里范围内自动调度订单</div>
						<div class="tips">最高不超过10公里</div>
					</el-form-item>
					<el-form-item label="自动取消">
						<div style="display: inline-block;">下单时间大于</div>
						<div style="display: inline-block; width: 7rem; margin: 0 0.625rem;">
							<el-input-number style="width: 100%;" v-model="form.auto_apply" controls-position="right"
								:min="0" :max="120" :precision="0"></el-input-number>
						</div>
						<div style="display: inline-block;">分钟未派单自动取消</div>
						<div class="tips">为0则不自动取消</div>
					</el-form-item>
					<template v-if="form.take">
						<el-divider content-position="left" style="margin: 1.25rem 0;">信息费设置</el-divider>
						<el-form-item label="跨区订单分成">
							<div style="display: inline-block;color: #00AEFF;font-weight: bold;">
								50%
							</div>
							<div class="tips">跨区订单信息费，跨区方和订单所属区域方各分50%</div>
						</el-form-item>
						<el-form-item label="公众号单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.g"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.gp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.gd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="小程序单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.d"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.dp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.dd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="扫码单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.m"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.mp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.md"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="自建单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.z"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.zp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.zd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="电话单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.s"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.sp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.sd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="优惠单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.y"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.yp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.yd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
						<el-form-item label="门店单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.h"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，加订单总金额</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.hp"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%，封顶</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.take.hd"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元（0为不限制）</div>
						</el-form-item>
					</template>
					<template v-if="form.discount">
						<el-divider content-position="left" class="zhekou">折扣设置</el-divider>
						<div style="margin-left: 7.5rem;margin-bottom: 1.25rem;font-size: 0.75rem;color: #8192A0;">
							<div>1、金额若设置一致则按固定金额折扣，反之则按金额<b style="color: red;">随机</b>折扣，<span
									style="color: red;">折扣金额不能高于最低起步价</span>；
							</div>
							<div>2、系统会根据司机承担比例补偿于司机，若司机承担比例100%，则不予补偿，相当于由司机出折扣费用。</div>
						</div>
						<el-form-item label="公众号单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.g[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.g[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.g[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="小程序单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.d[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.d[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.d[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="扫码单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.m[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.m[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.m[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="自建单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.z[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.z[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.z[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="电话单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.s[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.s[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.s[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="优惠单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.y[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.y[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.y[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
						<el-form-item label="门店单">
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.h[0]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元至</div>
							<div style="display: inline-block;width: 8rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.h[1]"
									controls-position="right" :min="0" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">元，司机承担比例</div>
							<div style="display: inline-block;width: 7rem;">
								<el-input-number style="width: 100%;" v-model.number="form.discount.h[2]"
									controls-position="right" :min="0" :max="100" :precision="0">
								</el-input-number>
							</div>
							<div style="display: inline-block;padding: 0 0.5rem;">%</div>
						</el-form-item>
					</template>
					<el-form-item>
						<div style="margin-top: 3.125rem;">
							<el-button type="primary" @click="submitSaveConfig" :loading="save_loading">保存设置</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				save_loading: false,
				rules: {},
				form: {}
			};
		},
		created() {
			this.postConfig();
		},
		methods: {
			refreshBesms() {
				var code = '';
				var numChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
				for (var i = 0; i < 6; i++) {
					var index = Math.floor(Math.random() * 10);
					code += numChar[index];
				}
				this.form.besms = code;
			},
			submitSaveConfig() {
				const that = this;
				var form = that.form;
				form.mode = "save";
				that.save_loading = true;
				that.$post('operateConfig', form).then(res => {
					setTimeout(function() {
						that.save_loading = false;
						that.$message.success("保存成功");
						that.postConfig();
					}, 500);
				}).catch(e => {
					that.save_loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			postConfig() {
				const that = this;
				that.loading = true;
				that.$post('operateConfig').then(res => {
					setTimeout(function() {
						that.loading = false;
						that.form = res.data;
					}, 500);
				}).catch(e => {
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.config>>>.el-form-item__label {
		color: #99a9bf;
	}

	.config .adcode {
		display: inline-block;
		color: #00AEFF;
		font-weight: bold;
	}

	.config .besms {
		display: inline-block;
		color: black;
		font-size: 1rem;
		font-weight: bold;
	}

	.config .el-icon-refresh-right {
		cursor: pointer;
		margin-left: 0.3rem;
		font-size: 1rem;
	}

	.config .tips {
		display: inline-block;
		margin-left: 1.25rem;
		color: #999;
		font-size: 0.75rem;
	}
</style>
